import PropTypes from 'prop-types';
import CompanySiteFooter from './Footer';
import CompanySiteHeader from './Header';
import { CompanySiteLayoutWrapper } from './styles';

function CompanySiteLayout({ children, company, basePath }) {
  return (
    <CompanySiteLayoutWrapper>
      <CompanySiteHeader company={company} basePath={basePath} />
      <main className="company-site-main">{children}</main>
      <CompanySiteFooter company={company} />
    </CompanySiteLayoutWrapper>
  );
}

CompanySiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
  company: PropTypes.shape({
    name: PropTypes.string,
    logoUrl: PropTypes.string,
  }),
  basePath: PropTypes.string,
};

CompanySiteLayout.defaultProps = {
  company: null,
  basePath: '',
};

export default CompanySiteLayout;
